// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2bGdu","ranges":"BmiRanges_ranges__1PAjt"};